
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-cyan-500 to-cyan-600 text-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <div className="mb-6">
            <img
              src="https://static.readdy.ai/image/6095022e0c468d9535f3b012298ccfc9/ef758113f5eb1527424f84f893360d0d.jpeg"
              alt="エアクリーンサービス江田島"
              className="w-40 h-auto mx-auto"
            />
          </div>
          <h3 className="text-2xl font-bold mb-2">エアクリーンサービス江田島</h3>
          <p className="text-cyan-100 font-normal text-sm leading-relaxed mb-6">江田島市を中心にエアコンクリーニングサービスを提供</p>
          
          {/* メインCTA: LINE */}
          <a
            href="https://lin.ee/ltlhjZa"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white/20 hover:bg-white/30 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 border border-white/40 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-lg"></i>
            <span>LINEで質問する</span>
          </a>
        </div>

        <div className="flex justify-center gap-8 mb-8">
          {/* 電話 */}
          <a href="tel:080-1752-6324" className="text-center group cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-2 group-hover:bg-white/20 transition-colors">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <p className="text-xs text-cyan-100 font-normal">電話</p>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/air_clean.etajima/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-center group cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-2 group-hover:bg-white/20 transition-colors">
              <i className="ri-instagram-fill text-2xl"></i>
            </div>
            <p className="text-xs text-cyan-100 font-normal">Instagram</p>
          </a>
        </div>

        <div className="text-center border-t border-white/20 pt-6">
          <p className="text-sm text-cyan-100 font-normal leading-relaxed mb-2">
            <i className="ri-map-pin-line mr-2"></i>
            広島県江田島市
          </p>
          <p className="text-sm text-cyan-100 font-normal leading-relaxed mb-4">
            一般社団法人 日本エアコンクリーニング協会 個人会員
          </p>
          <p className="text-xs text-cyan-100 font-normal">
            &copy; 2025 エアクリーンサービス江田島 All rights reserved.
          </p>
          <div className="mt-4">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-cyan-100 font-normal hover:text-yellow-300 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
